export default "__VITE_ASSET__Ccy9gWlh__"